import React, { FC } from 'react'
import { Arrow, ArrowRight, HomeIcon, ListBulletIcon } from '../../../../constants/svg'
import { TopicCTA } from '../../../../models/topics/cta'
import { localizedHomepageLink } from '../../../../utils/functions.utils'
import { internalLinkHandler } from '../../../../utils/link.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'

type Props = {
  homeLink: string
  entryLocale: string
  sections: any
  pageName: string
  currentPage: string
  nextPage: any
}

export const DisplayBreadcrumb: FC<Props> = ({
  homeLink,
  entryLocale,
  sections,
  pageName,
  currentPage,
  nextPage,
}) => {
  const nextCta: TopicCTA = nextPage
  const nextPageCtaLink = nextCta?.internalLink
    ? internalLinkHandler(nextCta.internalLink)
    : nextCta?.externalUrl || ''

  return (
    <>
      <div className="Breadcrumbs__CurrentPage">
        <a
          href={homeLink ? homeLink : localizedHomepageLink(entryLocale)}
          className="Breadcrumbs__Icon Breadcrumbs__Home-Icon">
          <HomeIcon />
        </a>

        <div className="Breadcrumbs__Next-Icon Breadcrumbs__Icon">
          <ArrowRight />
        </div>

        {sections?.map((section: any) => {
          return (
            <React.Fragment key={section.name}>
              <a href={section.sectionUrl}>
                <span className="Breadcrumbs__Link">{section.name}</span>
              </a>

              <div className="Breadcrumbs__Next-Icon Breadcrumbs__Icon">
                <ArrowRight />
              </div>
            </React.Fragment>
          )
        })}

        {pageName && (
          <p className="Breadcrumbs__Link Breadcrumbs__Link--Current FwCurrentPage">
            {formatInlineCode(pageName)}
          </p>
        )}
      </div>

      {nextCta && currentPage ? (
        <div className="Breadcrumbs__NextPage">
          <p className="Breadcrumbs__Link Breadcrumbs__Link--Current FwCurrentPage">
            {formatInlineCode(currentPage)}
          </p>
          <div className="Breadcrumbs__Next-Icon Breadcrumbs__Icon">
            <ListBulletIcon />
          </div>
          {nextCta && (
            <a href={nextPageCtaLink} className="nextPageLink">
              <span className="Breadcrumbs__Link">{nextCta?.text ? nextCta.text : ''}</span>
              <Arrow />
            </a>
          )}
        </div>
      ) : (
        ''
      )}
    </>
  )
}
